import { useContext, useMemo } from 'react';

import cn from 'classnames';

import { Link } from 'libs/router/Link';

import { ContentContext } from 'context/ContentContext';

import { useInt } from 'hooks/useInt';

import { Button } from 'ui/atoms/Button/Button';
import { Icon } from 'ui/atoms/Icon/Icon';

import { Burger } from '../Burger/Burger';
import { HeaderMenu } from '../HeaderMenu/HeaderMenu';
import { useHeaderMenu } from '../HeaderMenu/useHeaderMenu';
import { LanguageDropdown } from '../LanguageDropdown/LanguageDropdown';

export const Header = () => {
  const { pageVars, data: content, links, secondaryNavigation } = useContext(ContentContext);
  const { t } = useInt();

  const { menu, ItemMenu } = useHeaderMenu();

  const hasCountryPromotion = useMemo(() => 'country_promotion' in pageVars, [pageVars]);

  const isLP = useMemo(() => ['payg', 'payg_second'].includes(content.page_type), [content.page_type]);

  return (
    <div id="header" className={`header ${hasCountryPromotion ? 'is-country-promotion' : ''}`}>
      <div className={cn('header__container', isLP && 'header-container-payg')}>
        <Link className="header__logo" route="" ariaLabel="Home page">
          <Icon type={isLP ? 'logo-2' : 'logo-1'} className="header-logo" />
        </Link>

        {hasCountryPromotion === false ? (
          !isLP && (
            <>
              <Burger options={menu} className="hamburger-show" />

              <HeaderMenu menu={menu} ItemMenu={ItemMenu} />

              <div className="header__signin-div">
                {links.length > 0 && <LanguageDropdown />}

                <Button type="dark-outline" href={process.env.NEXT_PUBLIC_PLATFORM}>
                  {t('Sign in')}
                </Button>

                {secondaryNavigation.book_demo?.slug && (
                  <Button type="blue" route={secondaryNavigation.book_demo.slug}>
                    {t('Free Trial')}
                  </Button>
                )}
              </div>
            </>
          )
        ) : (
          <div className="header__contact-wrapper">
            <a href="tel:+44 203 640 6006">
              <Icon type="phone-2" />
              +44 203 640 6006
            </a>

            <a href="mailto:info@globaldatabase.com">
              <Icon type="footer-email" />
              info@globaldatabase.com
            </a>
          </div>
        )}
      </div>
    </div>
  );
};

// eslint-disable-next-line import/no-default-export
export default Header;
